// extracted by mini-css-extract-plugin
module.exports = {"tag":"Tag_tag__1K_ea","small":"Tag_small__2VC7G","inline":"Tag_inline__16eO0","hover":"Tag_hover__nilSU","selectedIcon":"Tag_selectedIcon__3d0T-"};